import { useQuery } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type SearchResult = { entity_type: string; entity_id: string; title: string; subtitle: string; number: string; url: string };
export type SearchGroup = { entity_type: string; label: string; results: SearchResult[] };

export function useGlobalSearch(q: string) {
  return useQuery({
    queryKey: ["global-search", q],
    enabled: q.trim().length >= 2,
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/search/", { params: { query: { q } } });
      if (error) throw new Error(errorMessage(error));
      return (data?.groups ?? []) as unknown as SearchGroup[];
    },
    staleTime: 10_000,
  });
}
